import axios from 'axios'
import Vue from 'vue'
import { Message } from 'element-ui'; // 引入Message组件
import { aesDecrypt, aesEncrypt, encodeAesKey, generateKey } from "@/untils/security.js";
import { recordOperationLog } from "@/api/log/log";

Vue.prototype.$message = Message;

// 基础配置
axios.defaults.baseURL = process.env.VUE_APP_BASE_HOST

// 设置请求超时
axios.defaults.timeout = 100000;

const aeskey = generateKey()

// 请求拦截器
axios.interceptors.request.use((config) => {
    // 检查是否是医保请求
    const isYbRequest = config.url?.includes('/api/business-handle')

    // 检查是否是Excel导入请求（不加密的请求）
    const isExcel = config.url?.includes('/outpatient/import') || config.url?.includes('/outpatient/traMedici/import');
    
    // 检查是否是中药导入请求（新增，明确不加密）
    const isTraMediciImport = config.url?.includes('/outpatient/traMedici/import');

    if (isExcel || isTraMediciImport) {
        config.headers['Content-Type'] = 'multipart/form-data'
        config.headers['clinicId'] = JSON.parse(localStorage.getItem("userInfo") || "{}").clinicId ?? ''
        config.headers['Authentication'] = localStorage.getItem('token')
        console.log("不加密请求（Excel/中药导入）:", config.url)
        return config
    }
    console.log(isYbRequest,'isYbRequestisYbRequestisYbRequestisYbRequest')
    if (isYbRequest) {
        config.headers['Content-Type'] = 'application/json';
        config.headers['Authentication'] = localStorage.getItem('token');
        config.headers['clinicId'] = JSON.parse(localStorage.getItem("userInfo") || "{}").clinicId ?? '';

        // 如果存在数据且为对象，则转为字符串并包装到inputData中
        if (config.data && typeof config.data === 'object' && !(config.data instanceof FormData)) {
            const jsonString = JSON.stringify(config.data);
            config.data = { inputData: jsonString };
        }
        // 如果已经是字符串，也可以包装？但根据需求，应该只针对对象，或者强制包装？我们可以做更严格的判断
        console.log("医保请求（数据包装为inputData）:", config.url);
        return config;
    }

    // 非医保请求正常加密
    config.headers['Authentication'] = localStorage.getItem('token')
    if (!(config.data instanceof FormData)) {
        config.headers['Content-Type'] = 'application/json';
    }
    config.headers['clinicId'] = JSON.parse(localStorage.getItem("userInfo") || "{}").clinicId ?? '';

    // 参数加密开关
    if (JSON.parse(process.env.VUE_APP_PARAM_ENCRYPTION)) {
        config.headers['security'] = encodeAesKey(aeskey)
        
        // 对数据进行加密处理
        if (config.data && typeof config.data === 'object' && !(config.data instanceof FormData)) {
            try {
                config.originalData = JSON.parse(JSON.stringify(config.data));
                const encryptedData = aesEncrypt(JSON.stringify(config.data), aeskey)
                config.data = encryptedData
                console.log("加密请求:", config.url, "原始数据:", config.data, "加密后:", encryptedData)
            } catch (error) {
                console.error("数据加密失败:", error)
                // 加密失败时使用原始数据
                console.log("加密失败，使用原始数据:", config.url)
            }
        } else {
            console.log("无需加密的请求数据:", config.url, config.data)
        }
    } else {
        console.log("加密开关关闭，使用明文请求:", config.url)
    }
    if (config.method?.toUpperCase() === 'GET' && config.params) {
        config.originalParams = JSON.parse(JSON.stringify(config.params));
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

function getOperParamFromConfig(config) {
    const method = config.method?.toUpperCase();

    // 优先使用备份的数据
    if (method === 'GET') {
        if (config.originalParams) {
            return JSON.stringify(config.originalParams);
        }
        // 备份不存在时回退
        return config.params ? JSON.stringify(config.params) : '';
    }

    // POST/PUT/DELETE
    if (config.originalData) {
        return JSON.stringify(config.originalData);
    }

    // 没有备份（不加密请求或备份失败）则按原逻辑取 config.data
    if (!config.data) return '';
    let rawData = config.data;
    if (typeof rawData === 'string') {
        // 可能是密文，但这里只在不加密请求中出现，所以是明文
        return rawData;
    } else if (rawData instanceof FormData) {
        let obj = {};
        rawData.forEach((val, key) => { obj[key] = val; });
        return JSON.stringify(obj);
    } else {
        return JSON.stringify(rawData);
    }
}
// 辅助函数：判断是否需要记录日志
function shouldRecordLog(config, responseData) {
    // 1. 跳过日志上报接口自身，避免死循环
    if (config.url?.includes('/outpatient/log')) return false;
    // 2. 必须有 code 字段且值不为 200
    return responseData && responseData.code !== undefined && responseData.code !== 200;
}

// 辅助函数：构建日志对象
function buildLogBody(config, responseData) {
    const requestMethod = config.method?.toUpperCase();
    const operParam = getOperParamFromConfig(config);
    return {
        businessType: 0,
        errorMsg: responseData?.message || '',
        jsonResult: JSON.stringify(responseData),
        method: config.url || '',
        operParam: operParam,
        operUrl: config.url || '',
        operatorType: 1,
        platform: 'web',
        requestMethod: requestMethod,
        title: document.title || ''
    };
}

// 新增：全局提示处理函数（仅处理错误，不再处理成功）
function handleGlobalMessage(data, config) {
    if (!data || typeof data.code !== 'number') return;

    // 只处理非200的错误情况（成功不再自动提示）
    if (data.code !== 200) {
        const errorMsg = data.message || '操作失败，请稍后重试';
        Message.error({
            message: errorMsg,
            duration: 4000  // 4秒
        });
    }
    // 成功时不做任何提示，由业务代码自行决定是否显示 this.$message.success
}

// 响应拦截器
axios.interceptors.response.use((response) => {
    try {
        const config = response.config;
        const isYbRequest = config?.baseURL === process.env.VUE_APP_BASE_YBHOST ||
            config?.url?.includes('/eapdomain/callService');
        const isExcel = config?.url?.includes('/outpatient/import') ||
            config?.url?.includes('/outpatient/traMedici/import');
        const isTraMediciImport = config?.url?.includes('/outpatient/traMedici/import');

        // ========== 不加密请求分支 ==========
        if (isYbRequest || isExcel || isTraMediciImport) {
            console.log("不加密响应:", config?.url, response.data);
            // 异地登录检查
            if (response.data?.code === 601) {
                handleIllegalLogin();
                return Promise.reject(response.data);
            }
            // 记录日志（条件判断）
            if (shouldRecordLog(config, response.data)) {
                recordOperationLog(buildLogBody(config, response.data));
            }
            // 全局提示（仅错误）
            handleGlobalMessage(response.data, config);
            return response.data;
        }

        // ========== 加密请求分支 ==========
        const decryptedData = aesDecrypt(response.data, aeskey);
        const data = JSON.parse(decryptedData);
        console.log("解密响应:", config?.url, data);

        // 记录日志（条件判断）
        if (shouldRecordLog(config, data)) {
            recordOperationLog(buildLogBody(config, data));
        }

        // 异地登录检查
        if (data.code === 601) {
            handleIllegalLogin();
            return Promise.reject(data);
        }
        // 全局提示（仅错误）
        handleGlobalMessage(data, config);
        return data;

    } catch (error) {
        // ========== 解密失败分支 ==========
        console.log("响应数据解密失败或未加密:", response.config?.url, response.data);
        const config = response.config;
        // 异地登录检查
        if (response.data?.code === 601) {
            handleIllegalLogin();
            return Promise.reject(response.data);
        }
        // 记录日志（条件判断）
        if (shouldRecordLog(config, response.data)) {
            recordOperationLog(buildLogBody(config, response.data));
        }
        // 全局提示（仅当数据有code字段时）
        if (response.data && typeof response.data.code === 'number') {
            handleGlobalMessage(response.data, config);
        }
        return response.data;
    }
}, (error) => {
    // 错误处理（网络错误、超时等）
    console.log("error（错误信息：):", error);
    const { response } = error;
    if (response) {
        switch (response.status) {
            case 600:
                Message.error({
                    message: response.data.message || '登录状态已过期',
                    duration: 4000
                });
                window.localStorage.clear();
                window.location.href = "#/login";
                return Promise.resolve();
            case 401:
                Message.error({
                    message: '请先登录',
                    duration: 4000
                });
                break;
            case 403:
                Message.error({
                    message: '没有操作权限',
                    duration: 4000
                });
                break;
            default:
                Message.error({
                    message: response.data.message || `请求错误 ${response.status}`,
                    duration: 4000
                });
        }
    } else {
        Message.error({
            message: '网络连接异常，请检查网络',
            duration: 4000
        });
    }
    return Promise.reject(error);
});

// 处理异地登录的函数
function handleIllegalLogin() {
    Vue.prototype.$message({
        message: '您的账号已在其他地方登录',
        type: 'error',
        duration: 0,
        showClose: false,
        onClose: () => {
            localStorage.clear();
            window.location.href = "#/login";
        }
    });

    // 5秒后自动关闭并跳转
    setTimeout(() => {
        Vue.prototype.$message.closeAll();
        localStorage.clear();
        window.location.href = "#/login";
    }, 5000);
}

// 暴露
export default axios;